<template>
  <ComponentsLayoutWithNavbar
    id="check-purchase"
    with_footer>
    <template #breadcrumbs>
      <NewPurchBread
        :check-exit="checkChages"
        class="pt-1"/>
    </template>
    <template #main_content>
      <v-card
        class="width-100 content-card pa-0 main__green"
        elevation="0">
        <StepNumber
          all_steps="3"
          step="3"/>
        <v-card-title class="h1-headline text-start pa-0 ">
          {{ $t('Catalog.CheckPurchase') }}
        </v-card-title>
        <v-card-subtitle class="h6-text black--text text-start pa-0 mt-4">
          <div>{{ $t('Catalog.CheckPurchText') }}</div>
          <div>{{ $t('Catalog.CheckPurchText2') }}</div>
        </v-card-subtitle>
        <v-card-text class="purchase-items px-0 mt-6 pb-0">
          <v-skeleton-loader
            v-if="loading "
            :boilerplate="false"
            class="mt-4"
            :tile="false"
            type=" table-thead, table-tbody, table-tbody"
            width="100%"/>
          <v-data-table
            v-else
            calculate-widths
            data-qa="table"
            disable-pagination
            fixed-header
            :headers="headers"
            hide-default-footer
            item-key="id"
            :items="rows"
            :no-data-text="$t('Tenders.NoData')">
            <template #[`item.name`]="{ item }">
              <ResourceName :item="item"/>
            </template>
            <template #[`item.declaredQuantity`]="{ item }">
              <span data-qa="item-quantity">{{ item.declaredQuantity | formSum }} {{ item.unit ? item.unit.name || item.unit.fullName: '–' }}</span>
            </template>
            <template #[`item.declaredSupplyDate`]="{ item }">
              <DateSpan
                data-qa="item-declaredSupplyDate"
                date="declared"
                :item="item"/>
            </template>
            <template #[`item.price`]="{ item }">
              <span data-qa="item-price">{{ item.price | formSum }}
                {{ item.price ? getCurrencyName(application, item.price) : '' }}</span>
            </template>
            <template #[`item.summa`]="{ item }">
              <span data-qa="item-summa">{{ (item.summa || (item.price * item.declaredQuantity) )| formSum }}
                {{ item.summa || (item.price * item.declaredQuantity)?
                  getCurrencyName(application, item.summa || (item.price * item.declaredQuantity)) : '' }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </template>
    <template #nav_bar="{ mini }">
      <v-container
        v-show="!mini"
        class="new-purchase-info mt-16 px-0 text-start main__light_green"
        justify-start>
        <template v-if="loading">
          <v-skeleton-loader
            class="mt-5 px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <template v-else>
          <v-card
            class="mx-4 pb-4 pt-3 name-card main__light_green mb-3"
            :class="{'secondary__green_chosen' : (application.title || edit_name) }"
            data-qa="card-application-title"
            elevation="0">
            <v-card-subtitle class="card-title py-0 justify-space-between d-flex align-center">
              <span class="h9-text text-uppercase">{{ $t('Catalog.PurchaseName') }}</span>
              <sButton
                v-if="(application.title && !edit_name) || edit_name"
                :data-qa="`btn-${application.title && !edit_name ? 'edit' : 'ok'}-edit-name`"
                :icon="application.title && !edit_name ? 'edit' : 'okay-arrow'"
                small
                type="text"
                @click.stop="edit_name = !edit_name"/>
            </v-card-subtitle>
            <v-card-subtitle
              v-if="!edit_name "
              class=" black--text py-0">
              <span
                v-if="!application.title"
                data-qa="application-no-title">{{ $t('Catalog.NameThePurchaseText') }}</span>
              <span
                v-if="application.title"
                data-qa="application-title">{{ application.title }}</span>
            </v-card-subtitle>
            <v-card-actions class="py-0 pl-4">
              <sButton
                v-if="!application.title && !edit_name"
                icon="plus"
                icon-size="10px"
                :rounded="false"
                small
                type="text"
                @click="edit_name = true">
                {{ $t('Common.Add') }}
              </sButton>
              <sInput
                v-if="edit_name"
                ref="name"
                clearable
                data-qa="input-application-title"
                max-length="254"
                rows="1"
                :value.sync="application.title"
                @blur="edit_name = false"
                @keydown_enter="edit_name = false"/>
            </v-card-actions>
          </v-card>
          <EditPurchAddress
            :address.sync="application.receiver"
            class="address-card"
            :class="application.receiver ? 'secondary__green_chosen' : 'main__light_green'"
            data-qa="card-edit-purch-address"
            :edit_address.sync="edit_address"/>
        </template>
      </v-container>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="previousStep"
        :back_btn="$t('Common.Edit')"
        :next_disable="load_prev">
        <template #next>
          <CreatedPurchaseDialog
            :changed="checkChages"
            :purchase="application"/>
        </template>
      </ComponentFooter>
    </template>
  </ComponentsLayoutWithNavbar>
</template>

<script>
import DateSpan from 'components/common/elements/DateSpan.vue'
import ResourceName from 'components/purchasing/ResourceName.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import NewPurchBread from 'components/purchasing/new purchase/NewPurchBread.vue'
import EditPurchAddress from 'components/purchasing/new purchase/EditPurchAddress.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'
import CreatedPurchaseDialog from 'components/purchasing/new purchase/CreatedPurchaseDialog.vue'

import ApplicationsApi from '@/api/applicationApi'
import { applicationMixin, beforeunloadMixin, filterSortMixin, modalMixin, tenderMixin } from 'mixins'
const api = new ApplicationsApi()

export default {
  name: 'checkPurchase',
  mixins: [ filterSortMixin, modalMixin, tenderMixin, applicationMixin, beforeunloadMixin ],
  data() {
    return {
      name: '',
      address: '',
      edit_name: false,
      edit_address: false,
      load_prev: false,
      loading: false,
      application: {},
      applicationItem: {},
      rows: []
    }
  },
  props: {
    app: [ Number, String],
    // loading: Boolean,
  },
  async created() {
    this.loading = true
    this.application = await this.getApp( this.app || +this.$route?.query?.id)
    if ( this.application.state != 'П' ) {
      this.$router.push( {name: 'purchitem', params: {id: this.application.id , org: this.$route.params.org }})
    }
    this.applicationItem = Object.assign({}, this.application)
    this.rows = this.$_.sortBy(this.application.rows, 'id').map((row, index) => ({...row, index: index + 1}))
    this.loading = false
  },
  computed: {
    headers() {
      return [
        {text: '', value: '', width: '35',  sortable: false},
        {text: this.$t('Catalog.Position'), value: 'name', sortable: false },
        {text: this.$t('Tenders.AdditionalDescription'), value: 'description',sortable: false, width: '20%'   },
        {text: this.$t('Catalog.Amount'), value: 'declaredQuantity',sortable: false, width: '13%'   },
        {text: this.$t('Catalog.DeliveryDate'), value: 'declaredSupplyDate', sortable: false, width: '13%' },
        {text: this.$t('Catalog.Price'), value: 'price', sortable: false, width: '13%' },
        {text: this.$t('Catalog.TotalCost'), value: 'summa', sortable: false, width: '13%' },
        {text: '', value: '', width: '35', sortable: false},
      ]
    },
  },
  methods: {
    checkChages() {
      return this.applicationItem.title != this.application?.title
        || this.applicationItem.receiver?.id != this.application?.receiver?.id
        || this.applicationItem.receiver?.organizationItId != this.application?.receiver?.organizationItId
    },
    async previousStep() {
      this.load_prev = true
      if ( this.checkChages()  ) {
        await api.editApplication({
          'id': this.application?.id,
          'title': this.application?.title,
          'receiverId': this.application?.receiver?.id  || this.application?.receiver?.organizationItId || null
        })
      }
      this.$emit('changeStep', false)
      this.load_prev = false
    },
  },
  components: {
    DateSpan,
    StepNumber,
    ResourceName,
    NewPurchBread,
    ComponentFooter,
    EditPurchAddress,
    CreatedPurchaseDialog,
    ComponentsLayoutWithNavbar
  }
}
</script>
<style lang="scss" scoped>
.address-card {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  width: calc(100% - 32px);
  margin: 0 auto;
}
.sticky {
  z-index: 6;
  position: sticky;
}
.content-card {

  .resource_group {
    font-size: 12px;
    line-height: 16px;
    min-height: 20px;
    height: 20px;
  }
  .v-card__title {
    span {
      font-weight: 500;
      font-size: 32px;
    }
    .card-title-text {
      height: 30px;
      font-size: 16px;
      color: var(--black-color);
      letter-spacing: -0.02em;
    }
  }
}
.to-draft-btn .btn{
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 0.02em;
}
.new-purchase-info {
  max-height: calc( 100vh - 140px);
  height: 100%;
  width: 100%;
  align-items: start;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  .v-card {
    width: calc(100% - 32px);
    border-radius: 8px;
  }
  .nav-actions {
    // position: absolute;
    height: 40px;
    max-height: 43px;
    bottom: 0;
    width: 100%;
    background-color: var(--white-color);
    z-index: 20;
    .btn {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.03em;
    }
  }
  .address .rows , .title{
    font-size: 16px;
    color: var(--text-color);
    text-align: start;
  }
  .btn  {
    line-height: 20px;
    font-size: 16px;
    color: var(--text-color);
  }
}
</style>
<style lang="scss">
#components-layout-check-purchase {
  .v-data-table tr {
    td {
      // cursor: pointer;
      min-height: 48px;
      padding: 10px !important;
    }
 }

  .v-data-table__wrapper {
    max-height: calc(100vh - 240px);
  }
}
</style>
